import { render, staticRenderFns } from "./DeleteAccountView.vue?vue&type=template&id=22919eec&scoped=true&"
import script from "./DeleteAccountView.vue?vue&type=script&lang=ts&"
export * from "./DeleteAccountView.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteAccountView.vue?vue&type=style&index=0&id=22919eec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22919eec",
  null
  
)

export default component.exports